<template>
<div class="container">
    <h3 class="is-size-5">Filter by Region</h3>
    <b-field  class='taginput continent-chooser wrap has-size-large'>
    <!-- <div class="block"> -->
        <b-radio-button v-model="selectedContinent"
            native-value="Africa">
            <span>Africa</span>
        </b-radio-button>
        <b-radio-button v-model="selectedContinent"
            native-value="Asia">
            <span>Asia</span>
        </b-radio-button>
        <b-radio-button v-model="selectedContinent"
            native-value="Europe">
            <span>Europe</span>
        </b-radio-button>
        <b-radio-button v-model="selectedContinent"
            native-value="North America">
            <span>North America</span>
        </b-radio-button>
        <b-radio-button v-model="selectedContinent"
            native-value="Oceania">
            <span>Oceania</span>
        </b-radio-button>
        <b-radio-button v-model="selectedContinent"
            native-value="South America">
            <span>South America</span>
        </b-radio-button>
        <b-radio-button v-model="selectedContinent"
            native-value="All">
            <span>All</span>
        </b-radio-button> 
    </b-field>
    <div class="spacer" style="height:70px"></div>
</div>


</template>

<script>
// import PageResultColumns from '@/components/PageResultColumns';
// import PageResult from '@/components/PageResult';

export default {
  name: 'ContinentFilter',
  components: {},
//   props: ['style_name'],
  data () {
    return {
        selectedContinent: "All"
    }
  },
  computed: {
  
  },
  watch: {
    selectedContinent: function (val) {
      this.$emit('continent-change', this.selectedContinent);
    }
  },
  methods: {
    updateValue() {
        this.$emit('continent-change', this.selectedContinent);
    }
    

  },
  
  mounted() {
    
     
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  

</style>

<style>
   
</style>


// WEBPACK FOOTER //
// src/components/ContinentFilter.vue